import script from "./invoice-details.vue?vue&type=script&setup=true&lang=js"
export * from "./invoice-details.vue?vue&type=script&setup=true&lang=js"

import "./invoice-details.vue?vue&type=style&index=0&id=3feee3c3&lang=css"

const __exports__ = script;

export default __exports__